export default __webpack_public_path__ + "static/media/infoCircleIcon.17e48fbd.svg";